import { action } from "typesafe-actions";
import { IQueryParams } from "../common/common.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { getSearchQuery } from "../common/helpers";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { ICompanyOutletAttachment } from "./companyOutletAttachment.types";
import { uploadFile } from "../../components/FileUpload/utils";

export const FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_PROGRESS =
  "FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_PROGRESS";
export const FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_SUCCESS =
  "FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_SUCCESS";
export const FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_FAILED =
  "FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_FAILED";

export const fetchCompanyOutletAttachmentListProgress = () =>
  action(FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_PROGRESS);
export const fetchCompanyOutletAttachmentListSuccess = (
  data: ICompanyOutletAttachment[],
  totalRecords: number
) =>
  action(FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_SUCCESS, {
    data,
    totalRecords,
  });
export const fetchCompanyOutletAttachmentListFailed = () =>
  action(FETCH_COMPANY_OUTLET_ATTACHMENT_LIST_FAILED);

export const fetchCompanyOutletAttachmentListAsync =
  (
    queryParams: IQueryParams,
    companyOutletUUID: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const searchQuery = getSearchQuery(queryParams);
      dispatch(fetchCompanyOutletAttachmentListProgress());
      let finalUrl = `/company/get-company-outlet-attachment${searchQuery}&company_outlet_uuid=${companyOutletUUID}&status=ACTIVE`;
      const res = await api.get(finalUrl);
      const data: ICompanyOutletAttachment[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchCompanyOutletAttachmentListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchCompanyOutletAttachmentListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertCompanyOutletAttachmentAsync =
  (
    payload: ICompanyOutletAttachment,
    file: any | null,
    onCallback: (
      isSuccess: boolean,
      returnedData?: ICompanyOutletAttachment
    ) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      let path = "";
      const asPayload = {
        company_outlet_name: payload.company_outlet_name,
      };
      path = await uploadFile({
        file: file,
        module_name: "COMPANY_OUTLET",
        defaultReturn: payload.link || "",
        asPayload: asPayload,
        onWarning: (message) => {
          dispatch(
            showMessage({
              type: "warning",
              message: message,
              displayAs: "snackbar",
            })
          );
        },
      });
      const { create_ts, insert_ts, rowId, ...rest } = payload;
      const res = await api.post("/company/upsert-company-attachments", {
        ...rest,
        link: path,
      });
      const data = res.data.data;
      onCallback(true, data);
      dispatch(
        showMessage({
          type: "success",
          message: "Document saved successfully!",
          displayAs: "snackbar",
        })
      );
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_COMPANY_OUTLET_ATTACHMENT =
  "CLEAR_COMPANY_OUTLET_ATTACHMENT";
export const CLEAR_COMPANY_OUTLET_ATTACHMENT_STATE =
  "CLEAR_COMPANY_OUTLET_ATTACHMENT_STATE";

export const clearCompanyOutletAttachment = () =>
  action(CLEAR_COMPANY_OUTLET_ATTACHMENT);
export const clearCompanyOutletAttachmentState = () =>
  action(CLEAR_COMPANY_OUTLET_ATTACHMENT_STATE);
